import { faArrowLeft, faPlus, faSave, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap"
import { Link, useNavigate, useParams } from "react-router-dom";
import { ButtonRemover, JTable, JTBody, JTHead, MakeMessageError } from "../../components/Components";
import { useEffect, useState } from "react";
import auxService from "../../services/AuxService";
import rotaService from "../../services/RotaService";
import { useQuestion } from "../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../components/ModalMessage/useModalMessage";

const initialFieldsError = {
    descricao: [],
    ufini: [],
    uffim: [],
    percurso: []
}

interface Percurso {
    uf: string;
}

interface formDataInterface {
    id?: string;
    descricao: string;
    ufini: string;
    uffim: string;
    percurso: Percurso[]
}

const initialStateForm: formDataInterface = {
    id: '',
    descricao: '',
    uffim: '',
    ufini: '',
    percurso: []
}

interface EstadoInterface {
    id: string;
    uf: string;
}

export const FormRota = () => {
    const navigate = useNavigate()
    const [formData, setFormData] = useState<formDataInterface>(initialStateForm);
    const { id } = useParams<{ id: string }>();
    const [errors, setErrors] = useState(initialFieldsError);
    const [estados, setEstados] = useState<EstadoInterface[]>([]);
    const [ufPercurso, setUfPercurso] = useState<string>("AC");
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (id) {
            rotaService.update(id, formData).then(res => {
                navigate("/rota");
            }).catch(error => {
                if (error.response) {
                    if (error.response.status === 422) {
                        setErrors(error.response.data)
                    }
                    if (error.response.status === 403) {
                        alertModal(error.response.data.message, 'danger');
                    }
                    navigate(`/rota/${id}`);
                }
            })

        } else {

            rotaService.create(formData).then(res => {
                navigate("/rota");
            }).catch(error => {
                if (error.response) {
                    if (error.response.status === 422) {
                        setErrors(error.response.data)
                    }
                    if (error.response.status === 403) {
                        alertModal(error.response.data.message, 'danger');
                    }
                    navigate(`/rota/create`);
                }
            })
        }

    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: "" }));
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: "" }));
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    const handleAdicionarPercurso = () => {
        if (formData.percurso.find((item: Percurso) => item.uf === ufPercurso)) {
            alertModal("UF já adicionada.");
            return;
        }

        if (ufPercurso === formData.uffim || ufPercurso === formData.ufini) {
            alertModal("Informe uma UF diferente inicio e fim");
            return;
        }

        if (formData.ufini === formData.uffim) {
            alertModal("UF inicio e fim não podem ser iguais.");
            return;
        }

        setFormData({
            ...formData,
            percurso: [...formData.percurso, { uf: ufPercurso }]
        })

        setErrors(prev => ({ ...prev, percurso: [] }));

    }

    const handleRemoverPercurso = async (uf: string) => {
        
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Remover <strong>{uf}</strong> ?</>
        })
        if (confirmed) {
            if (uf !== '') {
                setFormData({
                    ...formData,
                    percurso: formData.percurso.filter(item => item.uf !== uf)
                })
            }
        }
    }

    const handleRemoverPercursoTodos = async () => {
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Remover todos ?</>
        })
        if (confirmed) {
            setFormData({
                ...formData,
                percurso: []
            })
        }
    }

    const handleRemover = async () => {
        
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Deseja realmente remover <strong>{formData.descricao}</strong> ?</>
        })
        if (confirmed) {
            rotaService.delete(id).then(res => {
                alertModal('Removido com sucesso.', "success");
            })
            .catch(err => {
                const error400 = [403, 400, 409]
                if (error400.includes(err.response.status)) {
                    alertModal(err.response.data.message, 'danger');
                }
            })
        }
    }

    const disableUfs = () => {
        return formData.percurso.length > 0 ? true : false;
    }

    useEffect(() => {
        auxService.getEstados().then((estados) => {
            setEstados(estados);
            setFormData(prev => ({ ...prev, ufini: estados[0].uf, uffim: estados[0].uf }))

        })
    }, []);

    useEffect(() => {
        if (id) {
            rotaService.get(id).then(res => setFormData(res))
                .catch(err => navigate("/rota"))
        }
    }, [id])

    return (<>
        <Form onSubmit={handleSubmit} noValidate >
            <Card className="card-success card-outline">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <div className="my-0">

                        <Button variant={id ? 'primary' : 'success'} type="submit">
                            <FontAwesomeIcon icon={faSave} /> {id ? 'Salvar' : 'Criar'}
                        </Button>
                        <Link to="/rota" className="btn btn-secondary ms-1">
                            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                        </Link>
                    </div>
                    {id !== undefined && (
                        <Button variant={'danger'} type="button" className=" ms-1" onClick={() => handleRemover()}>
                            <FontAwesomeIcon icon={faTrash} /> Remover
                        </Button>

                    )}
                </Card.Header>
                <Card.Body>
                    <Row className="g-2">
                        <Col md>
                            <Form.Group className="mb-3" controlId="descricao">
                                <Form.Label>* Descrição</Form.Label>
                                <Form.Control maxLength={50} name="descricao" value={formData.descricao} type="text"
                                    className={`${errors.descricao?.length > 0 ? "is-invalid" : ""}`}
                                    autoFocus
                                    onChange={handleChange} />
                                <MakeMessageError errors={errors} field="descricao" />

                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3" controlId="ufini">
                                <Form.Label>* UF Inicio</Form.Label>


                                <Form.Select name="ufini" value={formData.ufini} disabled={disableUfs()}
                                    className={`${errors.ufini?.length > 0 ? "is-invalid" : ""}`}
                                    onChange={handleChangeSelect}
                                >
                                    {estados?.map((estado: EstadoInterface) => (
                                        <option key={estado.id} >{estado.uf}</option>
                                    )
                                    )}

                                </Form.Select>
                                <MakeMessageError errors={errors} field="ufini" />

                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group className="mb-3" controlId="uffim">
                                <Form.Label>* UF Fim</Form.Label>
                                <Form.Select name="uffim" value={formData.uffim} disabled={disableUfs()}
                                    className={`${errors.uffim?.length > 0 ? "is-invalid" : ""}`}
                                    onChange={handleChangeSelect}
                                >
                                    {estados?.map((estado: EstadoInterface) => (
                                        <option key={estado.id} >{estado.uf}</option>
                                    )
                                    )}

                                </Form.Select>
                                <MakeMessageError errors={errors} field="uffim" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <hr />

                    <Row className="g-2">
                        <Col md={'auto'}>
                            <Form.Group className="mb-3">
                                <Form.Label>UFs</Form.Label>
                                <InputGroup>
                                    <Form.Select name="percurso"
                                        onChange={(e: any) => {
                                            const { _, value } = e.target;
                                            setUfPercurso(value);
                                        }}
                                    >
                                        {estados?.map((estado: EstadoInterface) => (
                                            <option key={estado.id} value={estado.uf} >{estado.uf}</option>
                                        ))}

                                    </Form.Select>
                                    <Button onClick={handleAdicionarPercurso}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </Button>
                                </InputGroup>
                                <MakeMessageError errors={errors} field="percurso" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <JTable>
                        <JTHead>
                            <tr>
                                <th className="text-center" style={{ width: '2.5rem' }}>
                                    <ButtonRemover onClick={() => handleRemoverPercursoTodos()} icon={faTrashAlt} />
                                </th>
                                <th>UF</th>
                            </tr>
                        </JTHead>
                        <JTBody>
                            {formData.percurso?.map((item: Percurso) => (
                                <tr>
                                    <td className="text-center">
                                        <ButtonRemover onClick={() => handleRemoverPercurso(item.uf)} />
                                    </td>
                                    <td>{item.uf}</td>
                                </tr>
                            ))}
                        </JTBody>
                    </JTable>
                </Card.Body>
            </Card>
        </Form>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}